<template>
  <b-modal v-model="modal" hide-footer>
    <div class="d-block text-center">
      <h3>Required tasks are listed here</h3>
      <b-list-group v-if="!isLoading">
        <div
          class="flex-column align-items-start"
          v-if="incompletedBuyerTasks && incompletedBuyerTasks.length"
        >
          <div class="text-left">
            <h5 class="my-2">Buyer tasks</h5>
          </div>
          <b-list-group-item
            v-for="(task, index) in incompletedBuyerTasks"
            :key="index"
            class="text-left pb-3"
          >
            <p class="mb-1 text-uppercase">
              {{ task.name }}
            </p>
            <div
              v-for="(subTask, subtaskIndex) in task.subtask"
              :key="subtaskIndex"
              class="ml-3 mb-2"
            >
              <div v-if="subTask.value === false">
                <i class="fas fa-plus"></i> <span> {{ subTask.backName }}</span>
              </div>
              <div class="mt-1" v-if="subTask.value === false && subTask.note">
                <span
                  ><i>{{ subTask.note }}</i></span
                >
              </div>
            </div>
          </b-list-group-item>
        </div>

        <div
          class="flex-column align-items-start"
          v-if="incompletedSellerTasks && incompletedSellerTasks.length"
        >
          <div class="d-flex w-100 justify-content-between">
            <h5 class="my-2">Seller task</h5>
          </div>

          <b-list-group-item
            v-for="(task, index) in incompletedSellerTasks"
            :key="index"
            class="text-left pb-3"
          >
            <p class="mb-1 text-uppercase">
              {{ task.name }}
            </p>
            <div
              v-for="(subTask, subtaskIndex) in task.subtask"
              :key="subtaskIndex"
              class="ml-3 mb-2"
            >
              <div v-if="subTask.value === false">
                <i class="fas fa-plus"></i> <span> {{ subTask.backName }}</span>
              </div>
              <div class="mt-1" v-if="subTask.value === false && subTask.note">
                <span
                  ><i>{{ subTask.note }}</i></span
                >
              </div>
            </div>
        </b-list-group-item>
          </div>

        <div
          class="flex-column align-items-start"
          v-if="incompletedPropertyTasks && incompletedPropertyTasks.length"
        >
          <div class="d-flex w-100 justify-content-between">
            <h5 class="my-2">Property task</h5>
          </div>
          <b-list-group-item
            v-for="(task, index) in incompletedPropertyTasks"
            :key="index"
            class="text-left pb-3"
          >
            <p class="mb-1 text-uppercase">
              {{ task.name }}
            </p>
            <div
              v-for="(subTask, subtaskIndex) in task.subtask"
              :key="subtaskIndex"
              class="ml-3 mb-2"
            >
              <div v-if="subTask.value === false">
                <i class="fas fa-plus"></i> <span> {{ subTask.backName }}</span>
              </div>
              <div class="mt-1" v-if="subTask.value === false && subTask.note">
                <span
                  ><i>{{ subTask.note }}</i></span
                >
              </div>
            </div>
        </b-list-group-item>
          </div>
      </b-list-group>
      <div
        v-else
        class="text-center d-flex justify-content-center align-items-center mb-3 py-4 h-100"
      >
        <b-spinner
          small
          variant="primary"
          type="grow"
          label="Loading..."
        ></b-spinner>
        <b-spinner
          class="mx-4"
          small
          variant="primary"
          type="grow"
          label="Loading..."
        ></b-spinner>
        <b-spinner
          small
          variant="primary"
          type="grow"
          label="Loading..."
        ></b-spinner>
      </div>
    </div>
  </b-modal>
</template>
<script>
import { mapActions, mapMutations, mapState } from "vuex";
export default {
  name: "IncompleteTaskModal",
  props: ["data", "modalShow"],
  data() {
    return {
      isLoading: false,
      modal: false,
    };
  },
  computed: {
    ...mapState([
      "commonBuyerTask",
      "commonSellerTask",
      "commonPropertyTask",
      "proposalBuyerTask",
      "proposalSellerTask",
      "proposalPropertyTask",
    ]),
    incompletedBuyerTasks() {
      this.commonBuyerTask.forEach((commonTask) => {
        this.proposalBuyerTask.forEach((proposalTask) => {
          if (commonTask.id === proposalTask.id) {
            commonTask.value = proposalTask.value;
            if (proposalTask.updateRequired !== "never") {
              commonTask.required = proposalTask.required;
            }
            if (
              commonTask.subtask &&
              commonTask.subtask.length &&
              proposalTask.subtask &&
              proposalTask.subtask.length
            ) {
              commonTask.subtask.forEach((commonSubtask) => {
                proposalTask.subtask.forEach((subtask) => {
                  if (commonSubtask.id === subtask.id) {
                    commonSubtask.value = subtask.value;
                    commonSubtask.note = subtask.note;
                  }
                });
              });
            }
          }
        });
      });
      return this.commonBuyerTask.filter(
        (el) => el.value === false && el.required === true
      );
    },
    incompletedSellerTasks() {
      this.commonSellerTask.forEach((commonTask) => {
        this.proposalSellerTask.forEach((proposalTask) => {
          if (commonTask.id === proposalTask.id) {
            commonTask.value = proposalTask.value;
            if (proposalTask.updateRequired !== "never") {
              commonTask.required = proposalTask.required;
            }
            if (
              commonTask.subtask &&
              commonTask.subtask.length &&
              proposalTask.subtask &&
              proposalTask.subtask.length
            ) {
              commonTask.subtask.forEach((commonSubtask) => {
                proposalTask.subtask.forEach((subtask) => {
                  if (commonSubtask.id === subtask.id) {
                    commonSubtask.value = subtask.value;
                    commonSubtask.note = subtask.note;
                  }
                });
              });
            }
          }
        });
      });
      return this.commonSellerTask.filter(
        (el) => el.value === false && el.required === true
      );
    },
    incompletedPropertyTasks() {
      if (this.commonPropertyTask && this.proposalPropertyTask) {
        this.commonPropertyTask.forEach((commonTask) => {
          this.proposalPropertyTask.forEach((proposalTask) => {
            if (commonTask.id === proposalTask.id) {
              commonTask.value = proposalTask.value;
              if (proposalTask.updateRequired !== "never") {
                commonTask.required = proposalTask.required;
              }
              if (
                commonTask.subtask &&
                commonTask.subtask.length &&
                proposalTask.subtask &&
                proposalTask.subtask.length
              ) {
                commonTask.subtask.forEach((commonSubtask) => {
                  proposalTask.subtask.forEach((subtask) => {
                    if (commonSubtask.id === subtask.id) {
                      commonSubtask.value = subtask.value;
                      commonSubtask.note = subtask.note;
                    }
                  });
                });
              }
            }
          });
        });

        return this.commonPropertyTask.filter(
          (el) => el.value === false && el.required === true
        );
      } else {
        return [];
      }
    },
  },
  watch: {
    modal(newVal) {
      if (!newVal) {
        this.$emit("closeModal");
      }
    },
  },
  async mounted() {
    this.modal = this.modalShow;
    this.isLoading = true;
    await this.fetchCommonBuyer();
    this.fetchProposalBuyer(this.data.id);
    this.fetchCommonSeller();
    this.fetchProposalSeller(this.data.id);
    await this.fetchCommonProperty();
    this.fetchProposalProperty(this.data.id);
    this.isLoading = false;
  },
  methods: {
    ...mapActions([
      "fetchCommonBuyer",
      "fetchCommonSeller",
      "fetchCommonProperty",
      "fetchProposalBuyer",
      "fetchProposalSeller",
      "fetchProposalProperty",
    ]),
    ...mapMutations([
      "clearProposalBuyer",
      "clearProposalSeller",
      "clearProposalProperty",
    ]),
  },
};
</script>

<style scoped>
i.fas.fa-plus {
  font-size: 12px;
}
</style>
